import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/generic/Navbar';
import { Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext"

const PrivateLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated, logout, loading, user } = useAuth();

  console.log(user);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="private-layout flex flex-col md:flex-row h-screen overflow-hidden no-scrollbar bg-secondary/10">
      {/* DESKTOP SIDEBAR */}
      <div className="hidden md:block">
        <Navbar
          isAuthenticated={isAuthenticated}
          logout={logout}
          user={user}
        />
      </div>

      {/* MOBILE HAMBURGER BUTTON */}
      <div className="md:hidden border-b px-4 py-4 flex gap-2 items-center shrink-0">
        <button
          className="md:hidden z-50"
          onClick={() => setIsOpen(true)}
          aria-label="Open menu"
        >
          <Menu className="w-6 h-6 text-[#C5B191]" />
        </button>
        <img src={"/images/logos/BEIGELOGO.PNG"} alt={"beige logo"} className="h-10" />

      </div>
      {/* <button
        className=" fixed top-4 left-4 z-50 p-2 bg-white rounded-lg shadow-lg"
        onClick={() => setIsOpen(true)}
        aria-label="Open menu"
      >
        <Menu className="w-6 h-6" />
      </button> */}

      {/* MOBILE OVERLAY SIDEBAR */}
      {isOpen && (
        <>
          {/* BACKDROP */}
          <div
            className="fixed inset-0 bg-black/40 z-40"
            onClick={() => setIsOpen(false)}
          />

          <div className="fixed top-0 left-0 h-full w-72 bg-white dark:bg-zinc-900 shadow-xl z-50 overflow-auto">
            <div className='p-4'>
              <div className="flex items-start justify-between ">
                <img src={"/images/logos/BEIGELOGO.PNG"} alt={"beige logo"} className="h-10" />
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-2 rounded-md"
                  aria-label="Close menu"
                >
                  <X className="w-4 h-4 text-gray-700 dark:text-gray-200" />
                </button>
              </div>
              {/* <p className='text-sm px-2'>{user.name}</p> */}
            </div>
            <Navbar
              onClose={() => setIsOpen(false)}
              isAuthenticated={isAuthenticated}
              logout={logout}
              user={user}
            />
          </div>
        </>
      )}

      <div className="main-content flex-1 flex flex-col">
        <main
          className="private-content md:m-4 bg-accent/10 shadow-md md:rounded-2xl flex-1 overflow-y-auto hide-scrollbar transition-colors max-h-[calc(100vh-72px)] md:max-h-[calc(100vh-32px)]"
          // style={{ maxHeight: "calc(100vh - 72px)" }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateLayout;
